import { render, staticRenderFns } from "./exercisesResource.vue?vue&type=template&id=55abd118&"
import script from "./exercisesResource.vue?vue&type=script&lang=js&"
export * from "./exercisesResource.vue?vue&type=script&lang=js&"
import style0 from "./exercisesResource.vue?vue&type=style&index=0&id=55abd118&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55abd118')) {
      api.createRecord('55abd118', component.options)
    } else {
      api.reload('55abd118', component.options)
    }
    module.hot.accept("./exercisesResource.vue?vue&type=template&id=55abd118&", function () {
      api.rerender('55abd118', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/resource/exercisesResource.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/resource/exercisesResource.vue
// module id = Y6Ug
// module chunks = 0